import { TransferDetailsModel } from "model/TransferDetails.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = TransferDetailsModel | null;

export const useDefaultObservableTransferDetailsModelNull = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectTransferDetailsModelNull extends BehaviorSubject<CurrentType> {}
